import { paths } from '@/constants/paths';
import {
  getPathWithoutLocalePrefix,
  removePathPrefix,
} from '@/ui/utils/localization-helpers/localization';
import { DataLayerHelper } from '@/utils/data-layer-helper';

// Returns the pathname of an absolute URL, or the value itself for a relative path.
function toPathname(url: string): string {
  if (!/^https?:\/\//i.test(url)) {
    return url;
  }
  try {
    return new URL(url).pathname;
  } catch {
    return url;
  }
}

// Matches both footer link sources: the full Crystallize path of an internal link
// (e.g. /webhierarchydraft/withdraw) and the raw text of an external link.
export function isWithdrawalLink(url?: string | null): boolean {
  if (!url) {
    return false;
  }
  const [pathOnly] = toPathname(url.trim()).split(/[?#]/);
  const withoutHierarchy = removePathPrefix(pathOnly);

  return `/${getPathWithoutLocalePrefix(withoutHierarchy)}` === paths.withdrawal;
}

const pushWithdrawalStart = () => DataLayerHelper.pushWithdrawalStep(1, 'logged_out');

// Click handler for a footer link: tracks the public withdrawal entry, leaves every other link untouched.
export function getWithdrawalLinkClickHandler(url?: string | null): (() => void) | undefined {
  return isWithdrawalLink(url) ? pushWithdrawalStart : undefined;
}
